export default {
 hiddenSaveButton: (state) => state.hiddenSaveButton, 
 isLoading: (state) => state.isLoading
};
